import { render, staticRenderFns } from "./PreApprovalError.vue?vue&type=template&id=dd90e1ce&scoped=true&"
import script from "./PreApprovalError.vue?vue&type=script&lang=js&"
export * from "./PreApprovalError.vue?vue&type=script&lang=js&"
import style0 from "./PreApprovalError.vue?vue&type=style&index=0&id=dd90e1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd90e1ce",
  null
  
)

export default component.exports